/**
 * POST /auth/reset-password - Reset password with OTP
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import type { ResetPasswordInput } from '../auth.types.js'
import { getRequestInfo } from './helpers.js'

export const resetPasswordAction: ActionDefinition = {
  key: 'reset-password',
  label: { en: 'Reset Password', es: 'Restablecer contraseña' },
  icon: 'mdi:lock-reset',
  scope: 'module',
  group: { en: 'Authentication', es: 'Autenticación' },
  method: 'POST',
  skipAuth: true,
  middleware: (ctx) => (ctx.services.get('authRateLimits') as { login: MiddlewareHandler }).login,
  input: {
    email: { input: 'email', required: true, label: { en: 'Email', es: 'Correo electrónico' } },
    otp: { input: 'text', required: true, label: { en: 'OTP Code', es: 'Código OTP' }, validation: { min: 6, max: 6 } },
    newPassword: { input: 'password', required: true, label: { en: 'New Password', es: 'Nueva contraseña' }, validation: { min: 8 } }
  },
  handler: async (ctx, input, c) => {
    const body = input as ResetPasswordInput
    const authService = ctx.services.get<AuthService>('auth')
    await authService.resetPassword(body, getRequestInfo(c))
    return { message: 'Password reset successfully' }
  }
}
